module.exports = __webpack_public_path__ + "static/img/font.2fe4fb42.png";